<template lang="pug">
#sub-empresa-bloco-pesquisa-filtros
    .filtros
        .bloco-pesquisa-filtros__container
            .bloco-pesquisa-filtros__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='$t("mensagens.subEmpresaGestao.placehoder.pesquisaInteligente")',
                    autocomplete='off',
                    @keyup.enter='aplicarFiltros',
                    @input='limpar'
                )

        .filtros-data
            el-date-picker.input-data-cadastro(
                v-model='dataSelecionada',
                type='daterange',
                range-separator='-',
                format='dd/MM/yyyy',
                :clearable='false',
                :start-placeholder='$t("mensagens.subEmpresaGestao.placehoder.dataInicio")',
                :end-placeholder='$t("mensagens.subEmpresaGestao.placehoder.dataFim")',
                size='large',
                @change='aplicarFiltros'
            )

        section
            el-popover(
                placement='bottom',
                width='600',
                trigger='click',
                @show='obterDadosFiltro'
            )
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.subEmpresaGestao.placehoder.filtros') }}

                el-form(label-position='top')
                    .filtros-avancados__titulo
                        p {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.titulo') }}

                    .filtros-avancados__collapse
                        el-collapse(v-model='collapse', accordion)
                            el-collapse-item(
                                :title='$t("mensagens.menuLateral.sucursales")',
                                name='sucursal'
                            )
                                el-select(
                                    v-model='sucursalSelecionada',
                                    :placeholder='$t("mensagens.sucursales.placeholderSucursal")',
                                    filterable,
                                    clearable,
                                    style='width: 100%',
                                    @change='aplicarFiltros'
                                )
                                    el-option(
                                        v-for='sucursal in sucursais',
                                        :key='sucursal.id',
                                        :label='sucursal.nome',
                                        :value='sucursal.id'
                                    )
                            el-collapse-item(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.safra")',
                                name='safra'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='safraSelecionada',
                                    v-loading='carregandoSafra'
                                )
                                    el-checkbox.filtros-avancados__opcao(
                                        v-for='safra in safras',
                                        :label='safra.ano',
                                        :key='safra.id',
                                        :value='safra.ano',
                                        @change='aplicarFiltros'
                                    ) {{ safra.ano }}

                            el-collapse-item(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.status")',
                                name='status'
                            )
                                el-checkbox-group.alinhamento-status.filtros-avancados__opcoes(
                                    v-model='statusSelecionado',
                                    v-loading='carregandoStatusEmpresa'
                                )
                                    el-checkbox.filtros-avancados__opcao(
                                        v-for='status in statusEmpresa',
                                        :label='status.descricao',
                                        :key='status.codigo',
                                        :value='status.descricao',
                                        @change='aplicarFiltros'
                                    ) {{ $t(`mensagens.subEmpresaGestao.filtrosAvancados.statusSelecao.${status.codigo}`) }}

                            el-collapse-item.estados-municipios-filtro(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.localidade")',
                                name='municipio'
                            )
                                .estados-filtro
                                    p.sub-titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.selectDepartamento') }}
                                    el-select#estado(
                                        v-model='localidadeNivelUmSelecionado',
                                        :loading='carregandoLocalidadeNivelUm',
                                        @change='aplicarFiltros',
                                        @clear='limparLocalidadeNivelUm',
                                        clearable,
                                        filterable
                                    )
                                        el-option(
                                            v-for='{ sigla, id } in localidadeNivelUm',
                                            :key='id + sigla',
                                            :id='"estado-" + sigla',
                                            :label='sigla',
                                            :value='id'
                                        )

    .bloco-pesquisa-filtros__filtros-selecionados.mt-3(v-if='tags.length')
        span.filtros-selecionados__titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.filtrosSelecionados') }}
        el-tag.filtros-selecionados__tags(
            v-for='(tag, index) in tags',
            :key='index',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag }}

        el-tag.filtros-selecionados__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.limparFiltros') }}
            i.el-icon-delete
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import LocalidadeService from '@/services/LocalidadeService';
import SucursaleService from '@/services/SucursaleService';

export default {
    name: 'BlocoPesquisaInteligenteFiltrosPY',
    data() {
        return {
            collapse: null,
            tags: [],
            statusEmpresa: [],
            sucursais: [],
            sucursalSelecionada: null,
            safras: [],
            localidadeNivelUm: [],
            localidadeNivelDois: [],
            safraSelecionada: [],
            statusSelecionado: [],
            dataSelecionada: '',
            localidadeNivelUmSelecionado: '',
            localidadeNivelDoisSelecionado: [],
            pesquisa: '',
            carregandoStatusEmpresa: false,
            carregandoSafra: false,
            carregandoLocalidadeNivelUm: false,
            carregandoLocalidadeNivelDois: false
        };
    },
    methods: {
        aplicarFiltros() {
            this.tags = [];
            if (this.safras.length) this.tags.push(...this.safraSelecionada);
            // eslint-disable-next-line
            if (this.statusSelecionado.length) {
                this.tags.push(...this.statusSelecionado);
            }

            if (this.localidadeNivelUmSelecionado) {
                const departamento = this.localidadeNivelUm.find(
                    departamento =>
                        departamento.id === this.localidadeNivelUmSelecionado
                );
                this.tags.push(departamento.nome);
            }
            if (this.dataSelecionada) this.tags.push('dataDeCadastro');

            if (this.sucursalSelecionada) {
                const suc = this.sucursais.find(
                    s => s.id === this.sucursalSelecionada
                );
                if (suc) this.tags.push(suc.nome);
            }

            const filtro = {
                safras: this.obterIdsSafra(),
                status: this.obterIdsStatus(),
                dataCadastroInicio: this.converterData(this.dataSelecionada[0]),
                dataCadastroFim: this.converterData(this.dataSelecionada[1]),
                pesquisa: this.obterPesquisa(),
                idLocalidadeNivelUm: this.localidadeNivelUmSelecionado,
                idSucursal: this.sucursalSelecionada
            };
            this.$emit('emitFiltros', filtro);
        },
        converterData(date) {
            if (!this.dataSelecionada.length) return '';
            return new Date(date).getTime();
        },
        obterIdsStatus() {
            return (this.statusSelecionado ?? [])
                .map(
                    descricao =>
                        this.statusEmpresa.find(
                            ({ descricao: d }) => d === descricao
                        )?.codigo
                )
                .filter(Boolean);
        },
        obterIdsSafra() {
            if (!this.safraSelecionada) return [];
            return this.safraSelecionada.map(ano => {
                const statusObjeto = this.safras.find(
                    objeto => objeto.ano === ano
                );
                return statusObjeto ? statusObjeto.id : null;
            });
        },
        obterPesquisa() {
            if (!this.pesquisa) return '';
            return this.pesquisa;
        },
        limparFiltros() {
            this.tags = [];
            this.safraSelecionada = [];
            this.statusSelecionado = [];
            this.dataSelecionada = '';
            this.pesquisa = '';
            this.localidadeNivelUmSelecionado = '';
            this.municipioSelecionado = [];
            this.sucursalSelecionada = null;
            this.aplicarFiltros();
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            const indexSafra = this.safraSelecionada.indexOf(filtro);
            if (indexSafra !== -1) {
                this.safraSelecionada.splice(indexSafra, 1);
            }

            const indexStatus = this.statusSelecionado.indexOf(filtro);
            if (indexStatus !== -1) {
                this.statusSelecionado.splice(indexStatus, 1);
            }

            if (filtro === 'dataDeCadastro') {
                this.dataSelecionada = '';
            }

            if (this.sucursais.length) {
                const sucursal = this.sucursais.find(s => s.nome === filtro);
                if (sucursal && sucursal.id === this.sucursalSelecionada) {
                    this.sucursalSelecionada = null;
                }
            }

            if (this.municipioSelecionado.length) {
                let municipio = filtro.split(' - ');
                const indexMunicipio = this.municipioSelecionado.indexOf(
                    municipio[1]
                );
                if (indexMunicipio !== -1) {
                    this.municipioSelecionado.splice(indexMunicipio, 1);
                    if (!this.municipioSelecionado.length) {
                        this.localidadeNivelUmSelecionado = null;
                    }
                }
            }
        },
        formatarData(data, formatDate) {
            if (data) {
                const dia = formatDate(data, 'dd');
                const mes = formatDate(data, 'MM');
                const ano = formatDate(data, 'yyyy');
                return `${dia}, ${mes}, ${ano}`;
            }
            return '';
        },
        limpar() {
            if (this.pesquisa === '') this.aplicarFiltros();
        },
        obterDadosFiltro() {
            if (this.statusEmpresa.length && this.safras.length) {
                return;
            }
            this.getStatusSubEmpresa();
            this.getSafras();
            this.buscarLocalidadeNivelUm();
            this.getSucursales();
        },
        getSucursales() {
            SucursaleService.listagem()
                .then(({ data }) => {
                    this.sucursais = data.sucursais;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        async getStatusSubEmpresa() {
            this.carregandoStatusEmpresa = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.statusSubEmpresa();
                this.statusEmpresa = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de status.'
                });
            }
            this.carregandoStatusEmpresa = false;
        },
        async getSafras() {
            this.carregandoSafra = true;
            try {
                const { data } = await ContratoOriginacaoService.buscarSafras();
                this.safras = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de safras.'
                });
            }
            this.carregandoSafra = false;
        },
        async buscarLocalidadeNivelUm() {
            try {
                this.carregandoLocalidadeNivelUm = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm(false);

                this.localidadeNivelUm = data;
                this.carregandoLocalidadeNivelUm = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os estados.');
            }
        },
        async buscarLocalidadeNivelDois() {
            this.localidadeNivelDoisSelecionado = [];

            if (!this.localidadeNivelUmSelecionado) return;

            try {
                this.carregandoLocalidadeNivelUm = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(
                        this.localidadeNivelUmSelecionado,
                        false
                    );

                this.localidadeNivelDois = data;
                this.carregandoLocalidadeNivelUm = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os municipios.');
            }
        },
        async limparLocalidadeNivelUm() {
            if (this.localidadeNivelDoisSelecionado.length) {
                this.localidadeNivelDoisSelecionado.forEach(n2 => {
                    let localidadeNivelUm = this.localidadeNivelUm.find(n1 => {
                        return n1.id === this.localidadeNivelUmSelecionado;
                    });
                    this.tags.splice(
                        this.tags.indexOf(localidadeNivelUm.sigla + ' - ' + n2),
                        1
                    );
                });
                this.localidadeNivelUmSelecionado = null;
                this.municipioSelecionado = [];
            }
            this.aplicarFiltros();
        },
        obterIdsLocalidadeNivelDois() {
            if (!this.localidadeNivelDoisSelecionado) return [];
            return this.localidadeNivelDoisSelecionado.map(nome => {
                const idObjeto = this.localidadeNivelDois.find(
                    objeto => objeto.nome === nome
                );
                return idObjeto ? idObjeto.id : null;
            });
        },
        municipioNome() {
            const nomeObjeto = this.municipios.find(
                objeto => objeto.id === this.municipioSelecionado
            );
            return nomeObjeto ? nomeObjeto.nome : null;
        }
    }
};
</script>

<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}
.filtros {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    gap: 10px;
}

.bloco-pesquisa-filtros__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
}

.filtros-data {
    box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
}

.input-data-cadastro {
    height: 43px !important;
    .el-input__inner {
        height: 43px !important;
    }
}

.bloco-pesquisa-filtros__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--gray);
        font-size: 16px;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.bloco-pesquisa-filtros__filtros-selecionados {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
}

.filtros-selecionados__limpar {
    cursor: pointer;
}

.filtros-avancados__titulo {
    color: var(--primary);
    font-weight: bold;
}

.filtros-avancados__opcoes {
    font-size: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.el-collapse-item.estados-municipios-filtro.is-active,
.el-collapse-item.estados-municipios-filtro {
    .el-collapse-item__content {
        display: flex;
        gap: 15px;
        padding-bottom: 25px;
        font-size: 13px;
        color: #303133;
        line-height: 1.7692307692;

        .sub-titulo {
            margin: 0;
            color: #808080;
        }

        .municipios-filtro,
        .estados-filtro {
            display: flex;
            flex-direction: column;
        }
    }
}
</style>
